<template>
    <svg xmlns="http://www.w3.org/2000/svg"
        :width="width"
        :height="height"
        viewBox="0 0 20 19.013"
        aria-labelledby="all_right"
        role="presentation">

    <title>all_right</title>
    <g :fill="iconColor">
        <g id="layer_2" data-name="layer 2">
            <g id="layer_1-2" data-name="layer 1">
                <path class="cls-1" d="M4.991,10.694a.92.92,0,0,0,0,1.3l1.392,1.391a.279.279,0,0,1,0,.393l-.657.656H5.4L2.275,11.311a.281.281,0,0,1-.082-.2V6.785a.918.918,0,0,0-.918-.918H.918A.918.918,0,0,0,0,6.785V13.7a.571.571,0,0,0,.167.4l3.648,3.646a1.057,1.057,0,0,1,.308.745v.261a.253.253,0,0,0,.253.253H8.9a.252.252,0,0,0,.252-.253V13.488L6.29,10.694A.92.92,0,0,0,4.991,10.694Z"/>
                <path class="cls-1" d="M19.082,5.867h-.357a.918.918,0,0,0-.918.918v4.329a.281.281,0,0,1-.082.2L14.6,14.433h-.328l-.657-.656a.279.279,0,0,1,0-.393l1.392-1.391a.919.919,0,0,0-1.3-1.3l-2.862,2.794V18.76a.252.252,0,0,0,.252.253h4.524a.253.253,0,0,0,.253-.253V18.5a1.057,1.057,0,0,1,.308-.745l3.648-3.646A.571.571,0,0,0,20,13.7V6.785A.918.918,0,0,0,19.082,5.867Z"/>
                <path class="cls-1" d="M14.362.8a2.719,2.719,0,0,0-3.844,0l-.417.417a.142.142,0,0,1-.2,0L9.482.8A2.718,2.718,0,0,0,5.638,4.64L9.784,8.786a.306.306,0,0,0,.432,0L14.362,4.64A2.719,2.719,0,0,0,14.362.8Z"/>
            </g>
        </g>
    </g>
    </svg>
</template>

<script>

export default {
  props: {
    width: {
      type: Number,
      default: 18
    },
    height: {
      type: Number,
      default: 18
    },
    iconColor: {
      type: String,
      default: 'gray'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/icon/AllRight.vue